import ToggleMenu from '@page/common/js/global/ToggleMenu';

var NowMyEquipment = nowEnv.NowMyEquipment;

export default {
  corpPage: function () {
    if (NowMyEquipment) {
      ToggleMenu('.corp-menu > h2');
    }

    $(window).trigger('checkImg', {
      type: 'hidden',
      target: '.corp-content',
    });
  },
};
